import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuotationActionsService {
  private quoteSubject = new Subject<void>();
  private cartCheckoutSubject = new Subject<void>();

  cartCheckoutClick$ = this.cartCheckoutSubject.asObservable();
  click$ = this.quoteSubject.asObservable();

  quoteAdded() {
    this.quoteSubject.next();
  }

  checkoutClicked(){
    this.cartCheckoutSubject.next();
  }
  constructor() { }
}
